import type { ServerResponse } from "@/http"
import type { IEventVaultResponse } from "@/types"
import { axios } from "@/axios"
import { EventVault } from "@/models"

// eslint-disable-next-line unused-imports/no-unused-vars
const possibleIncludes = ["zip", "template", "settings"] as const
export type IPossibleIncludes = (typeof possibleIncludes)[number]

export interface IListEventVaultQueryParams {
  page?: number
  perPage?: number
  include?: IPossibleIncludes[]
  status?: string
  product?: string
  sortBy?: string
  orderBy?: "desc" | "asc"
  hostAccountId?: number
}

export async function listEventVaults({
  page,
  perPage,
  include,
  status,
  product,
  sortBy,
  orderBy,
  hostAccountId,
}: IListEventVaultQueryParams = {}) {
  const query = new URLSearchParams()

  if (page)
    query.append("page", page.toString())
  if (perPage)
    query.append("perPage", perPage.toString())
  if (include)
    query.append("include", include?.toString())
  if (status)
    query.append("status", status)
  if (product)
    query.append("product", product)
  if (sortBy)
    query.append("sort", sortBy)
  if (orderBy)
    query.append("order", orderBy)
  if (hostAccountId)
    query.append("hostAccountId", hostAccountId.toString())

  const response = await axios.get<ServerResponse<IEventVaultResponse[]>>(`/api/event?${query.toString()}`)

  return {
    links: response.data.Links,
    eventVaults: response.data.Data?.map(eventVault => EventVault.fromResponse(eventVault)) ?? [],
  }
}
